import { Component, Inject, OnInit } from '@angular/core';
import { InstitutoResponse } from './shared/models/intituto-info.model';
import { DiplomaSearchService } from './shared/services/diploma-search.service';

import { ActivatedRoute, Router } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';
import { Title } from "@angular/platform-browser";
import { BaseService } from './shared/services/base.service';
import { IAutenticacao } from './core/models/autenticacao';
import { LoaderService } from './shared/services/loader.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  isLoading: boolean = true;
  title = 'DiplomaDigital';
  fragment: boolean | null = null;

  constructor(private searchService: DiplomaSearchService,
              public activateRouter: ActivatedRoute,
              private titleService: Title,
              private baseService: BaseService,
              private activatedRouter: ActivatedRoute,
              public loaderService: LoaderService,
              @Inject(APP_BASE_HREF) public baseHref: string){}

  ngOnInit() {
    this.onVerifyInstitute();
  }

  onVerifyInstitute(){
    // let baseHrefMod: string = '/piedade/aluno/diploma-digital/';
    let baseHrefMod = this.baseHref;
    let folders: string[] = baseHrefMod.split("/");
    let paramRefPath: string = '';

    folders.forEach((folder: string) => {
      if(folder != '' && folder != 'diploma-digital' && folder != 'aluno') paramRefPath = folder;
    });
    
    this.activateRouter.queryParams
      .subscribe(params => {         
        this.searchService.onGetInfoIntitute(params.referer, paramRefPath).subscribe((data: IAutenticacao) => { 
          this.onSetStyleIntitute(data);
        },(error: any) =>{ console.log('INSTITUTO error: ', error); });
      }
    );
  }

  onSetStyleIntitute(data: IAutenticacao){
    const favIcon: HTMLLinkElement | null = document.querySelector('#appIcon');
    if(data.dados.instituto != undefined){
      let institute: InstitutoResponse = data.dados.instituto;
      const nome: string = institute.nome;
      const instituto = institute.sigla;
      const css = `${this.baseService.URL_CDN}/cdn/diploma/${instituto}/style.css`;
      const head = document.getElementsByTagName('head')[0];
      const style = document.createElement('link');
      style.rel = 'stylesheet';   
      style.type = 'text/css';  
      style.href = css;
      head.appendChild(style);
      favIcon!.href = `${this.baseService.URL_CDN}/cdn/diploma/${instituto.toLowerCase()}/img/favicon.png`;
      this.titleService.setTitle(`Diploma Digital - ${nome} - ${instituto}`);
    }
    else
      favIcon!.href = `${this.baseService.URL_CDN}/cdn/diploma/SUAFACULDADE/img/favicon.png`;
    
    this.activatedRouter.fragment.subscribe(frag => {
     frag ? this.fragment = true : this.fragment = false;
      console.log('FRAGMENT: ', this.fragment);
    });
    
    setTimeout(() => {
      this.loaderService.setLoading(false);
    }, this.fragment ? 2000 : 1000);
  }

}
